import Vue from 'vue';
import { UserAccountState } from './state';
import { MutationTree } from 'vuex';
import { Provider } from '@/helpers/accountsIframe';

const mutations: MutationTree<UserAccountState> = {
  SET_STUDENT_EMAIL_PROVIDER(state, providers: Provider[]) {
    state.studentEmailProvider = providers;
  },
  SET_STUDENT_EMAIL_HAS_ACCOUNTS(state, hasAccounts: boolean) {
    state.studentEmailHasAccounts = hasAccounts;
  },
  SET_EMAIL_TOKEND(state, email: string) {
    state.emailTokenD = email;
  },
  SET_AUTH_TOKEN(state, authToken: string) {
    Vue.$cookies.set('admissions-auth-token', authToken, '7d', '/', '.descomplica.com.br');
  },
};

export default mutations;
